import { useEffect, useRef, useState } from 'react'
import { GEOMETRY_BLOCKED_PULSE_MS } from '@/components/app/editor/selection-chrome/geometry-blocked-feedback'

/** Replays the red blocked-gesture flash whenever the manager's pulse key increments. */
export function useGeometryBlockedPulse(pulseKey: number): boolean {
  const lastConsumedRef = useRef(pulseKey)
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (pulseKey <= lastConsumedRef.current) return

    lastConsumedRef.current = pulseKey
    setActive(true)

    const timer = window.setTimeout(() => setActive(false), GEOMETRY_BLOCKED_PULSE_MS)

    return () => window.clearTimeout(timer)
  }, [pulseKey])

  return active
}
